import React from 'react';
import { SidebarContainer, Icon, CloseIcon, SidebarWrapper, SidebarMenu, SidebarLink, SideBtnWrap, SidebarRoute } from './SidebarElements';

const Sidebar = ({ isOpen, toggle }) => {
    return (
        <SidebarContainer isOpen={ isOpen } onClick={ toggle }>
            <Icon onClick={ toggle }>
                <CloseIcon />
            </Icon>
            <SidebarWrapper>
                <SidebarMenu>
                    <SidebarLink smooth={true} duration={500} spy={true} exact="true" offset={-80} to="about" onClick={ toggle }>
                        <span>O Stowarzyszeniu</span>
                    </SidebarLink>
                    <SidebarLink smooth={true} duration={500} spy={true} exact="true" offset={-80} to="projects" onClick={ toggle }>
                        <span>Projekty</span>
                    </SidebarLink>
                    <SidebarLink smooth={true} duration={500} spy={true} exact="true" offset={-80} to="contact" onClick={ toggle }>
                        <span>Kontakt</span>
                    </SidebarLink>
                </SidebarMenu>
                <SideBtnWrap>
                    <SidebarRoute smooth={true} duration={500} spy={true} exact="true" offset={-80} to="support1Per" onClick={ toggle }>
                        Wesprzyj Stowarzyszenie
                    </SidebarRoute>
                </SideBtnWrap>
            </SidebarWrapper>
        </SidebarContainer>
    )
}

export default Sidebar;
